function _tagged_template_literal(strings, raw) {
    if (!raw) {
        raw = strings.slice(0);
    }
    return Object.freeze(Object.defineProperties(strings, {
        raw: {
            value: Object.freeze(raw)
        }
    }));
}
function _templateObject() {
    var data = _tagged_template_literal([
        "\n  display: block;\n  width: fit-content;\n  height: 19px;\n  line-height: 157%;\n  border-radius: 34px;\n  color: #fff;\n  font-weight: bold;\n  font-size: 12px;\n  padding: 0px 10px;\n  background-color: ",
        ";\n  margin-bottom: 9px;\n  margin-right: 9px;\n  font-style: normal;\n"
    ]);
    _templateObject = function _templateObject() {
        return data;
    };
    return data;
}
import { jsx as _jsx } from "react/jsx-runtime";
import _ from 'lodash';
import React from 'react';
import styled from 'styled-components';
import { formatDiscountForDisplay } from 'shared/helpers/specials';
export default function DiscountBadge(param) {
    var className = param.className, displayText = param.displayText, type = param.type, _param_isMobile = param.isMobile, isMobile = _param_isMobile === void 0 ? false : _param_isMobile, originalPrice = param.originalPrice, discountedPrice = param.discountedPrice, item = param.item, option = param.option, value = param.value, _param_forceDollarFormat = param.forceDollarFormat, forceDollarFormat = _param_forceDollarFormat === void 0 ? false : _param_forceDollarFormat, _param_calculationMethod = param.calculationMethod, calculationMethod = _param_calculationMethod === void 0 ? null : _param_calculationMethod;
    var specialsText;
    // Display overrides
    if (displayText) {
        specialsText = displayText;
    // Sales
    } else if (type === 'sale') {
        // value is a deprecated attribute
        if (!_.isNil(value)) {
            specialsText = "".concat(value, "% off");
        } else {
            specialsText = formatDiscountForDisplay(originalPrice, discountedPrice, item, type, option, false, forceDollarFormat, calculationMethod);
        }
    // Offers
    } else if (!_.isNil(value)) {
        // value is a deprecated attribute
        specialsText = isMobile ? "$".concat(value, " discount!") : "$".concat(value, " discount applied!");
    } else {
        specialsText = formatDiscountForDisplay(originalPrice, discountedPrice, item, type, option, isMobile, forceDollarFormat, calculationMethod);
    }
    // formatDiscountForDisplay returns null when there is no displayable discount (e.g. rounds to 0%)
    if (!specialsText) {
        return null;
    }
    return /*#__PURE__*/ _jsx(Container, {
        className: className,
        type: type,
        children: /*#__PURE__*/ _jsx("span", {
            children: specialsText
        })
    });
}
var Container = styled.div(_templateObject(), function(props) {
    return props.type === 'sale' ? '#f3583a' : '#4ca667';
});
